import { Dictionary, has, keyBy } from 'lodash';
import { useMemo, useCallback } from 'react';
import { Holiday, HolidayCalendar } from 'api/holiday-calendar/types';
import { useHolidayCalendars } from 'queries/holiday-calendar';

export const useHolidayCalendar = (holidayCalendarId?: number) => {
  const { data: holidayCalendarsLookup } = useHolidayCalendars();

  const enabledHolidayCalendarsLookup: Dictionary<HolidayCalendar> = useMemo(
    () =>
      keyBy(
        Object.values(holidayCalendarsLookup || {}).filter(
          (calendar) => calendar.enabled,
        ),
        'holidayCalendarId',
      ),
    [holidayCalendarsLookup],
  );

  const enabledHolidayCalendars = useMemo(
    () =>
      Object.values(holidayCalendarsLookup || {}).filter(
        (calendar) => calendar.enabled,
      ),
    [holidayCalendarsLookup],
  );

  let holidayCalendar: HolidayCalendar | undefined;

  if (holidayCalendarId) {
    holidayCalendar = has(enabledHolidayCalendarsLookup, holidayCalendarId)
      ? enabledHolidayCalendarsLookup[holidayCalendarId]
      : undefined;
  }

  const getCalendarHolidays = useCallback(
    (holidayCalendarIdValue?: number): Holiday[] => {
      let holidays: Holiday[] = [];

      if (holidayCalendarIdValue) {
        holidays = has(enabledHolidayCalendarsLookup, holidayCalendarIdValue)
          ? enabledHolidayCalendarsLookup[holidayCalendarIdValue].holidays
          : [];
      }

      return holidays || [];
    },
    [enabledHolidayCalendarsLookup],
  );

  return { enabledHolidayCalendars, holidayCalendar, getCalendarHolidays };
};
